import request from '@/utils/request';

export class HomeService {
  protected serviceApi: string = 'Home';

  public Course(count: number) {
    return request({
      url: `${this.serviceApi}/course/${count}`,
      method: 'get',
    });
  }

  public Book(courseId: number, count: number) {
    return request({
      url: `${this.serviceApi}/book/${courseId}/${count}`,
      method: 'get',
    });
  }
}
